const routes = [
  { path: "/admin/dashboard", title: "Dashboard", isLast: true },
  // Admins list page
  { path: "/admin/admins", title: "Admins", isLast: true },
  { path: "/admin/customers", title: "Customers", isLast: false },
  { path: "/admin/customers/detail", title: "Customer Profile", isLast: true },
  { path: "/admin/posts", title: "Posts", isLast: false },
  { path: "/admin/posts/detail", title: "Post Detail", isLast: true },
  // Admin add page
  { path: "/admin/admins/add", title: "Add Admins", isLast: true },
  {
    path: "/admin/trip-plans/upcoming",
    title: "Upcoming Trip Plans",
    isLast: false,
  },
  { path: "/admin/trip-plans/past", title: "Past Trip Plans", isLast: false },
  {
    path: "/admin/trip-plans/upcoming/",
    title: "Upcoming Trip Detail",
    isLast: true,
  },
  { path: "/admin/trip-plans/past/", title: "Past Trip Detail", isLast: true },
  { path: "/admin/transactions", title: "Transactions", isLast: false },
  {
    path: "/admin/transactions/detail",
    title: "Transaction Detail",
    isLast: true,
  },
  { path: "/admin/report", title: "Report", isLast: true },
  { path: "/admin/setting", title: "Setting", isLast: true },
];
export default routes;



// WEBPACK FOOTER //
// ./client/react/Admin/routes.js